export default "__VITE_ASSET__BNaMfXh8__"